import { Injectable, OnDestroy } from '@angular/core';

import { Observable, Subject, Subscriber } from 'rxjs';

import { BarEditPageLoadOptions } from './bar-edit-page-load-options.model';
import { BarEditPageLoadReason } from './bar-edit-page-load-reason.enum';
import { BarEditPageSaveOptions } from './bar-edit-page-save-options.model';

@Injectable()
export class BarEditPageService implements OnDestroy {
    // internal observables
    private __load$ = new Subject<{ model: any; options: BarEditPageLoadOptions; subscriber: Subscriber<void> }>();
    private __requestSave$ = new Subject<{ options: BarEditPageSaveOptions; subscriber: Subscriber<boolean> }>();
    private __undo$ = new Subject<{ subscriber: Subscriber<void> }>();
    private __delete$ = new Subject<{ subscriber: Subscriber<boolean> }>();
    /** Internal property. Do not use. */
    _load$ = this.__load$.asObservable();
    /** Internal property. Do not use. */
    _requestSave$ = this.__requestSave$.asObservable();
    /** Internal property. Do not use. */
    _undo$ = this.__undo$.asObservable();
    /** Internal property. Do not use. */
    _delete$ = this.__delete$.asObservable();

    ngOnDestroy(): void {
        this.__load$.complete();
        this.__requestSave$.complete();
        this.__undo$.complete();
        this.__delete$.complete();
    }

    /** Invokes the load on the edit page with a given model. */
    load(model: any, options = { loadModel: true, reason: BarEditPageLoadReason.Load, callOnLoad: true } as BarEditPageLoadOptions): Observable<void> {
        return new Observable<void>((subscriber) => {
            this.__load$.next({ model, options, subscriber });
        });
    }

    /** Requests a save with validation and returns a flag determining whether it was saved. */
    requestSave(options: BarEditPageSaveOptions): Observable<boolean> {
        return new Observable<boolean>((subscriber) => {
            this.__requestSave$.next({ options, subscriber });
        });
    }

    /** Performs the undo. */
    undo(): Observable<void> {
        return new Observable<void>((subscriber) => {
            this.__undo$.next({ subscriber });
        });
    }

    /** Performs delete and returns a flag determining whether it was deleted. */
    delete(): Observable<boolean> {
        return new Observable<boolean>((subscriber) => {
            this.__delete$.next({ subscriber });
        });
    }
}
